<template>
  <div>      <div class="header">

    <div class="logo-new">
      <div class="top_nav" style="position:absolute;right: 60px;top: 1px;">
        </div>
        <h2>
            <a href="http://sme.miit.gov.cn/chengxin/"></a>
        </h2>
    </div><!--div class="release"><img src="/cms/resource/8a8900c96a48cf51016a4c70e1e80136//style/images/head_banner.gif" width="900" height="90"/></div-->
</div>
      <div id="nav-bar">
    <div class="nav-bar">
        <ul class="nav">
          <router-link to='/' tag="li"><a>首页</a></router-link>
            <li>
                <a href="http://sme.miit.gov.cn/cms/news/100000/0000000812/0000000812.shtml" target="_blank" title="信用动态" _href="/cms/news/100000/0000000812/0000000812.shtml" textvalue="信用动态">信用动态</a>
            </li>
            <li>
                <a href="http://sme.miit.gov.cn/cms/news/100003/index.shtml" target="_blank" title="政策法规" _href="/cms/news/100003/index.shtml" textvalue="政策法规">政策法规</a>
            </li>
          <router-link to='/creditsearch' tag="li"><a>公示查询</a></router-link>
          <router-link to='/evaluation' tag="li" style="display: none"><a>评价申请</a></router-link>
            <li>
                <a href="http://sme.miit.gov.cn/cms/show.action?code=publish_8a8380b9645fe4f50164abf41fa73b3a&amp;siteid=100000&amp;newsid=ddfea0dd038e4dc9b17c6fd787b6cc18&amp;channelid=0000000814" title="信用服务" target="_blank">信用服务</a>
            </li>
            <li>
                <a href="http://sme.miit.gov.cn/cms/news/100000/0000000815/0000000815.shtml" target="_blank" title="诚信访谈" _href="/cms/news/100000/0000000815/0000000815.shtml" textvalue="诚信访谈">诚信访谈</a>
            </li>
        </ul>
        <div class="clearfix"></div>
    </div>
</div>
    <div class="body1" style="min-height: 400px">
      <el-form v-if="sso !== true" ref="form1" :model="form1" :rules="rules"  label-width="80px" style="margin-top: 20px;margin-bottom: 100px">
      <div style="font-size: 35px;font-weight: bold;text-align: center;margin-top: 80px;margin-bottom: 80px;">诚信管理系统登录</div>
      <el-form-item label="用户名：" prop="username" style="margin-left: -100px">
        <el-input v-model="form1.username"></el-input>
      </el-form-item >
       <el-form-item  label="密码：" prop="password" style="margin-left: -100px">
        <el-input type="password" v-model="form1.password"></el-input>
      </el-form-item>
      <el-form-item style="margin-left: -100px">
        <el-button type="primary" @click="checkForm('form1')" style="width:100%" @keyup.enter.native="checkForm('form1')">登录</el-button>
      </el-form-item>
</el-form>
       <el-button  icon="el-icon-user" style="margin: 80px 100px 80px 100px;width: 400px;height: 150px;font-size: 40px" type="primary" v-if="sso === true" @click="tosso()">管理员登录</el-button>
    </div></div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataPost } from '@/api/index'

export default {
  name: 'signin',
  data () {
    var userName = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    var passWord = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        callback()
      }
    }
    return {

      form1: {
        username: '',
        password: '',
        sso: ''
      },
      rules: {
        username: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
          { validator: userName, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
          { validator: passWord, trigger: 'blur' }
        ]
      }
    }
  },
  created  () {
    var that = this
    that.sso = rootPathssb.sso
    // if (rootPathssb.sso) {
    //   dataPost(rootPathssb.rootPath + '/admin/signin').then(function (response) {
    //     console.log(response)
    //     console.log(that.$route.query.cssSsoTicket)
    //   })
    // }
  }, // 页面加载时
  methods: {
    tosso () {
      var that = this
      if (rootPathssb.sso) {
        dataPost(rootPathssb.rootPath + '/admin/signin').then(function (response) {
          console.log(response)
          console.log(that.$route.query.cssSsoTicket)
        })
      }
    },
    submitForm (event) {
      var params = new URLSearchParams()
      params.append('username', this.form1.username)
      params.append('password', this.form1.password)
      this.$http.post(rootPathssb.rootPath + '/admin/signin', params).then(function (response) {
        if (response.data.result === 0) { alert(response.data.msg) };
        if (response.data.result === 1) {
          // localStorage.setItem('Admin-Auth', response.data.token)
          // localStorage.setItem('Admin-Auth',that.form1.username)
          window.location.href = '/adminleftlist'
          console.log('cg')
        };

        console.log(response.data)
      })
    },
    checkForm (formName) {
      let that = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          that.submitForm()
          console.log('成功!')
        } else {
          console.log('提交失败')
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.body1{
  width:600px;
  margin: 0 auto;
}
  .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    background-color: #f5f5f5;
    color: #333;
    width: 100%;
    margin: 0 auto;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  .header {
    margin: 10px auto;
    width: 1200px;
    height: 153px;
}
  .header .logo-new {
    width: 1200px;
    height: 153px;
    background: url(../../assets/img/logo-new.jpg) no-repeat;
}
  #nav-bar {
    background: #0081d3;}
  .nav-bar {
    margin: 10px auto 10px;
    width: 1200px;
}
  .nav-bar ul {
    height: 35px;
    font-size: 18px;
    color: #fff;
    list-style-type: none;
    width: 1000px;
    margin: auto;
}
   .top_nav a{
      text-decoration:none;
   }
  .top_nav ul li{
     list-style-type: none;

  }
 .nav-bar ul li {
    display: inline-block;
    float: left;
    padding: 0 40px;
    line-height: 35px;
    font-size: 18px;
    text-align: center;
   list-style-type: none;
}
  .nav-bar a {
    color: #fff;
    text-decoration: none;
}
  .tab_c6 {
    width: 1200px;
    height: 120px;
    margin: 10px auto 0;
    text-align: center;
}
  .tab_c6_lx {
    background-color: #ddd;
    font-size: 14px;
    color: #000;
    line-height: 35px;
}

.tab_c6_lx  a {
    color: #000;
    text-decoration: none;
}
  .tab_c6_foot {
    font-size: 12px;
    color: #888;
    line-height: 28px;
}
  .tab_c6_foot ul {
    float: left;
    width: 930px;
    margin-left: 200px;
    list-style: none;
}
  .tab_c6_foot li {
    width: 930px;
    text-align: center;
    float: left;
    color: #333;
    font-size: 14px;
    line-height: 28px;
}
  .tab_c6_foot li h4 {
    margin-right: 20px;
    text-align: center;
    float: left;
    line-height: 28px;
    font-weight: normal;
}
 .zddw{
   margin-top: 20px;
 }
  .lxfs{
    margin-right: 50px;
    width: 200px;
  }
  .jz{
        width: 600px;
    margin: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/computer/signin.vue